export const formatCurrency = (price, locale = "en-IN", currency = "INR") => {
  const curr = price.toLocaleString(locale, {
    style: "currency",
    currency,
  });
  return curr;
};